import React, { useEffect, useState } from "react";
import Mapir from "mapir-react-component";
import "mapir-react-component/dist/index.css";
import LocationImg from "../../../src/assets/images/Profile/Frame_431.png";
import "./mapir.scss";
const Map = Mapir.setToken({
  transformRequest: (url) => {
    return {
      url: url,
      headers: {
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImUwZGQ0MmEwNTVjNTcwNGI3ZTU4MmI2OTc3NzY1MzM2NjEwMjllZDM2MzBlOTk0MDkzYzBhOWUzNDIzMzZkNmQwM2YxMjBmMDJjMmI3ZjExIn0.eyJhdWQiOiIyMDA0NSIsImp0aSI6ImUwZGQ0MmEwNTVjNTcwNGI3ZTU4MmI2OTc3NzY1MzM2NjEwMjllZDM2MzBlOTk0MDkzYzBhOWUzNDIzMzZkNmQwM2YxMjBmMDJjMmI3ZjExIiwiaWF0IjoxNjY4ODA4MTMwLCJuYmYiOjE2Njg4MDgxMzAsImV4cCI6MTY3MTMxMzczMCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.SIGOXjwWMvLEj67F6uWpNoUTd3FAuZTDvdnnqM7JPs4263jHk--mMNKsKlHYWdIr3QRhP3hdiDgeVe4n9t3CSN5K4i2O1IsRA9W1sicHzIvpX8kO-fBNXLExS62EMS_gHLWWVNsfDPC8oCdmsNeR-tdukoy5w3EK2DLtp34kB4upyYruH3gTaZVntSYh3e6gD4j5AkuU3thNL4H0YdLWEQDtniIsn9_BVwv9Sxmf4E-3ZFh-VJSmmqCRdvAZ0h3iEHsBNrJJ4NUZT6-hEanLop8evr8xBhTlCgl4vDZVJ2ctdakZaqXm1Nojrv2VXWSZI4kYotteyj8I2sf-GlE7JA", //Mapir api key
        "Mapir-SDK": "reactjs",
      },
    };
  },
});

const MapIR = ({
  location = {
    lngLat: { lng: 54.42787580000132, lat: 36.84725311840381 },
  },
  height,
  setAddress,
  setLocation,
  setNextstep = () => {},
}) => {
  const [popupArray, setPopupArray] = useState();
  const [showMarker, setShowMarker] = useState(true);

  useEffect(() => {}, [location.lngLat.lat]);

  function reverseFunction(e) {
    var url = `https://map.ir/reverse/no?lat=${e.lat}&lon=${e.lng}`;
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImUwZGQ0MmEwNTVjNTcwNGI3ZTU4MmI2OTc3NzY1MzM2NjEwMjllZDM2MzBlOTk0MDkzYzBhOWUzNDIzMzZkNmQwM2YxMjBmMDJjMmI3ZjExIn0.eyJhdWQiOiIyMDA0NSIsImp0aSI6ImUwZGQ0MmEwNTVjNTcwNGI3ZTU4MmI2OTc3NzY1MzM2NjEwMjllZDM2MzBlOTk0MDkzYzBhOWUzNDIzMzZkNmQwM2YxMjBmMDJjMmI3ZjExIiwiaWF0IjoxNjY4ODA4MTMwLCJuYmYiOjE2Njg4MDgxMzAsImV4cCI6MTY3MTMxMzczMCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.SIGOXjwWMvLEj67F6uWpNoUTd3FAuZTDvdnnqM7JPs4263jHk--mMNKsKlHYWdIr3QRhP3hdiDgeVe4n9t3CSN5K4i2O1IsRA9W1sicHzIvpX8kO-fBNXLExS62EMS_gHLWWVNsfDPC8oCdmsNeR-tdukoy5w3EK2DLtp34kB4upyYruH3gTaZVntSYh3e6gD4j5AkuU3thNL4H0YdLWEQDtniIsn9_BVwv9Sxmf4E-3ZFh-VJSmmqCRdvAZ0h3iEHsBNrJJ4NUZT6-hEanLop8evr8xBhTlCgl4vDZVJ2ctdakZaqXm1Nojrv2VXWSZI4kYotteyj8I2sf-GlE7JA",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setAddress(data.address_compact);
      });

    setLocation({
      lngLat: { lng: e.lng, lat: e.lat },
    });
    p = new Point(e.lat, e.lng);
    // Function call
    if (checkInside(polygon, n, p)) {
      setNextstep(true);
      setShowMarker(true);
      setPopupArray([]);
    } else {
      setNextstep(false);

      setShowMarker(false);
      setPopupArray(
        <Mapir.Popup
          coordinates={[e.lng, e.lat]}
          offset={{
            "bottom-left": [12, -38],
            "bottom-right": [-12, -38],
          }}
        >
          <h1>
            سبدی در آدرس انتخاب‌ شده در دسترس نیست.
            <br />
            به زودی در شهر شما خدمات خواهیم داشت.
          </h1>
        </Mapir.Popup>
      );
    }
  }

  return (
    <div className="App">
      <Mapir
        center={[location.lngLat.lng, location.lngLat.lat]}
        Map={Map}
        onDrag={(e) => {
          reverseFunction(e.getCenter());
        }}
        containerStyle={{ height: `${height}px`, borderRadius: "6px" }}
        userLocation
      >
        {popupArray}
        <Mapir.ZoomControl position="top-left" />
        {showMarker && (
          <div
            id="center-marker"
            style={{ backgroundImage: `url(${LocationImg})`, zIndex: "2" }}
          ></div>
        )}
      </Mapir>
    </div>
  );
};

export default MapIR;

// from https://www.geeksforgeeks.org/how-to-check-if-a-given-point-lies-inside-a-polygon/
class Point {
  //int x, y;
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }
}

class line {
  //Point p1, p2;
  constructor(p1, p2) {
    this.p1 = p1;
    this.p2 = p2;
  }
}

function onLine(l1, p) {
  // Check whether p is on the line or not
  if (
    p.x <= Math.max(l1.p1.x, l1.p2.x) &&
    p.x <= Math.min(l1.p1.x, l1.p2.x) &&
    p.y <= Math.max(l1.p1.y, l1.p2.y) &&
    p.y <= Math.min(l1.p1.y, l1.p2.y)
  )
    return true;

  return false;
}

function direction(a, b, c) {
  let val = (b.y - a.y) * (c.x - b.x) - (b.x - a.x) * (c.y - b.y);

  if (val == 0)
    // Colinear
    return 0;
  else if (val < 0)
    // Anti-clockwise direction
    return 2;

  // Clockwise direction
  return 1;
}

function isIntersect(l1, l2) {
  // Four direction for two lines and points of other line
  let dir1 = direction(l1.p1, l1.p2, l2.p1);
  let dir2 = direction(l1.p1, l1.p2, l2.p2);
  let dir3 = direction(l2.p1, l2.p2, l1.p1);
  let dir4 = direction(l2.p1, l2.p2, l1.p2);

  // When intersecting
  if (dir1 != dir2 && dir3 != dir4) return true;

  // When p2 of line2 are on the line1
  if (dir1 == 0 && onLine(l1, l2.p1)) return true;

  // When p1 of line2 are on the line1
  if (dir2 == 0 && onLine(l1, l2.p2)) return true;

  // When p2 of line1 are on the line2
  if (dir3 == 0 && onLine(l2, l1.p1)) return true;

  // When p1 of line1 are on the line2
  if (dir4 == 0 && onLine(l2, l1.p2)) return true;

  return false;
}

function checkInside(poly, n, p) {
  // When polygon has less than 3 edge, it is not polygon
  if (n < 3) return false;

  // Create a point at infinity, y is same as point p
  let tmp = new Point(9999, p.y);
  let exline = new line(p, tmp);
  let count = 0;
  let i = 0;
  do {
    // Forming a line from two consecutive points of
    // poly
    let side = new line(poly[i], poly[(i + 1) % n]);
    if (isIntersect(side, exline)) {
      // If side is intersects exline
      if (direction(side.p1, p, side.p2) == 0) return onLine(side, p);
      count++;
    }
    i = (i + 1) % n;
  } while (i != 0);

  // When count is odd
  return count & 1;
}

// Driver code
let polygon = [
  new Point(36.841976, 54.364889),
  new Point(36.851007, 54.362102),
  new Point(36.83885, 54.36841),
  new Point(36.83844, 54.408775),
  new Point(36.821208, 54.413472),
  new Point(36.809063, 54.44781),
  new Point(36.799055, 54.45597),
  new Point(36.79356, 54.465681),
  new Point(36.798955, 54.470541),
  new Point(36.821869, 54.457751),
  new Point(36.847406, 54.481206),
  new Point(36.835233, 54.47979),
  new Point(36.858749, 54.468659),
  new Point(36.868366, 54.445062),
  new Point(36.863201, 54.446175),
  new Point(36.860738, 54.428191),
  new Point(36.853046, 54.413085),
  new Point(36.852222, 54.380126),
];
let p = new Point(5, 3);
let n = 18;
